// Exports the "spellchecker" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/spellchecker')
//   ES2015:
//     import 'tinymce/plugins/spellchecker'
require('./plugin.js');


// WEBPACK FOOTER //
// ./src/packages/tinymce/plugins/spellchecker/index.js